import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/gameEventTab.css';
// helpers
import {calculateTimeDifference, formatTimeToHHMM} from '../../../helpers/helperFunctions';
// actions
import {selectEvent, setselectedMatchdaySubEventIndex} from '../../../actions/eventsActions';
import {NEXT_EVENT_DISPLAY_MODE} from "../../../constants/bmsLogic";
import {
    CURRENT_NEXT,
    VPP_MATCHDAY_BELGIUM_CHANNEL,
    VPP_MATCHDAY_ENGLISH_CHANNEL,
    VPP_MATCHDAY_GREEK_CHANNEL,
    VPP_MATCHDAY_MOROCCAN_CHANNEL,
    VPP_MATCHDAY_TURKISH_CHANNEL
} from "../../../constants/identifiers";
import {getText} from '../../../helpers/localization';

const mapStateToProps = (state, ownProps) => {
    return {isVideoVisible: state.vpp.isVideoVisible};
};

class GameEventTab extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            games: storeData.vpp.games,
            matchdayIndex: props.matchdayIndex,
            isVideoVisible: storeData.vpp.isVideoVisible,
            timeLeft: calculateTimeDifference(Date.now() - storeData.vpp.serverTimeOffset, props.eventDate) / 1000
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();
        if (nextProps && storeData) {
            this.setState({
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                games: storeData.vpp.games,
                matchdayIndex: nextProps.matchdayIndex
            });
        }
    }

    _updateTimeLeft() {
        let store = this.props.store;
        let storeData = store.getState();

        this.setState({
            isVideoVisible: storeData.vpp.isVideoVisible,
            timeLeft: calculateTimeDifference(Date.now() - storeData.vpp.serverTimeOffset, this.props.eventDate) / 1000
        });
    }

    componentDidMount() {
        //create the time ticker if it's the first event (this means that has a counter)
        if (this.props.eventindex === 0) {
            this.interval = setInterval(this._updateTimeLeft.bind(this), 1000);
        }
    }

    componentWillUnmount() {
        if (this.props.eventindex === 0) {
            //clear the time ticker if it's the first event (this means that has a counter)
            clearInterval(this.interval);
            //Reset matchday sub-tab selected index
            this.props.store.dispatch(setselectedMatchdaySubEventIndex(0, this.props.store));
        }
    }

    _clickTab(index) {
        if (this.props.store) {
            this.props.store.dispatch(selectEvent(index));
            this.props.store.dispatch(setselectedMatchdaySubEventIndex(0, this.props.store));
        }
    }

    render() {

        let blinkingColor = () => {
            let timeLeft = Math.floor(this.state.timeLeft);
            if (timeLeft < 0) {
                return '';
            } else if (timeLeft <= 15) {
                return style.blinkingRed;
            } else if (timeLeft <= 30) {
                return style.blinkingAmber;
            } else {
                return '';
            }
        };

        let gameEventTabStyle = NEXT_EVENT_DISPLAY_MODE === CURRENT_NEXT ? ` ${style.gameEventTab} ${style.gameEventTabLiveAndNext}` : style.gameEventTab;
        let arrowDownStyle = NEXT_EVENT_DISPLAY_MODE === CURRENT_NEXT ? ` ${style.arrowDown} ${style.arrowDownLiveAndNext}` : style.arrowDown;
        let matchdayPrefix = '';
        if (this.state.games[this.state.selectedGameIndex].channel === VPP_MATCHDAY_ENGLISH_CHANNEL ||
            this.state.games[this.state.selectedGameIndex].channel === VPP_MATCHDAY_TURKISH_CHANNEL ||
            this.state.games[this.state.selectedGameIndex].channel === VPP_MATCHDAY_GREEK_CHANNEL ||
            this.state.games[this.state.selectedGameIndex].channel === VPP_MATCHDAY_MOROCCAN_CHANNEL ||
            this.state.games[this.state.selectedGameIndex].channel === VPP_MATCHDAY_BELGIUM_CHANNEL) {
            matchdayPrefix = '-' + getText('MD', this.props.store, [this.state.matchdayIndex]);
            gameEventTabStyle += ' ' + `${style.gameEventTabMatchday}`;
        }
        return (
            <div
                id={'gameEventTab_' + this.props.eventindex}
                className={`${gameEventTabStyle} ${this.props.eventindex === 0
                    ? style.first
                    : ''} ${this.props.isSelected
                    ? style.selected
                    : ''}`}
                onClick={() => this._clickTab(this.props.eventindex)}>

                <div>
                    {

                        /* insert a transparent overlay over the counter div for the blinking behaviour */
                        this.props.eventindex === 0 && blinkingColor() !== ''
                            ? <div
                                className={`${blinkingColor()}`}>{this.props.timerText + formatTimeToHHMM(this.props.eventDate) + matchdayPrefix}</div>
                            : this.props.timerText + formatTimeToHHMM(this.props.eventDate) + matchdayPrefix
                    }
                </div>
                <div>
                    {
                        /* insert an arrow if is the first event and the video is showing*/
                        (this.props.isSelected)
                            ? <center><span className={`${arrowDownStyle}`}/></center>
                            : ''
                    }
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(GameEventTab);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/gameEventTab.js